import React, { useEffect } from 'react';
import '../About/About'; // Make sure this CSS file contains the necessary styles

const AchievementsSection = () => {
    // Effect for fade-in animations on elements with the 'animatable' class
    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, { threshold: 0.1 });

        const elements = document.querySelectorAll('.animatable');
        elements.forEach(el => observer.observe(el));
        
        // Cleanup function to unobserve elements
        return () => elements.forEach(el => observer.unobserve(el));
    }, []);

    // Effect for the number counter animation
    useEffect(() => {
        const statsSection = document.querySelector('.stats-section-wrapper');
        
        // Ensure the section exists before observing
        if (!statsSection) return;

        const observer = new IntersectionObserver((entries, obs) => {
            const [entry] = entries;
            if (!entry.isIntersecting) return;

            const counters = document.querySelectorAll('.stat-number');
            counters.forEach(counter => {
                // Prevent re-animating if it has already been animated
                if (counter.classList.contains('animated')) return;
                counter.classList.add('animated');

                const target = +counter.getAttribute('data-target');
                const duration = 1500; // Animation duration in ms
                const stepTime = Math.max(1, Math.floor(duration / target)); // Ensure stepTime is at least 1
                let start = 0;
                
                const timer = setInterval(() => {
                    start += 1;
                    counter.textContent = start;
                    if (start >= target) {
                        clearInterval(timer);
                        // Use data-format attribute to add '%' or '+'
                        const format = counter.getAttribute('data-format') || '';
                        counter.textContent = `${target}${format}`;
                    }
                }, stepTime);
            });
            // Stop observing after the animation has triggered once
            obs.unobserve(statsSection);
        }, { threshold: 0.5 });

        observer.observe(statsSection);

        // Cleanup function to unobserve the element
        return () => {
            if (statsSection) observer.unobserve(statsSection);
        };
    }, []);

    return (
        // STATS SECTION / ACHIEVEMENTS
        <div className="stats-section-wrapper">
            <div className="container animatable">
                <div className="section-header">
                    <h2>Our Achievements</h2>
                    <p>Some key statistics from our work over the years.</p>
                </div>
                <div className="stats-grid">
                    <div className="stat-item">
                        <h3 className="stat-number" data-target="99" data-format="%">0%</h3>
                        <p>Patient Satisfaction</p>
                    </div>
                    <div className="stat-item">
                        <h3 className="stat-number" data-target="800" data-format="+">0+</h3>
                        <p>Successful Surgeries</p>
                    </div>
                    <div className="stat-item">
                        <h3 className="stat-number" data-target="24">0</h3>
                        <p>Years of Experience</p>
                    </div>
                    <div className="stat-item">
                        <h3 className="stat-number" data-target="15" data-format="+">0+</h3>
                        <p>Medical Specialities</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AchievementsSection;